// @ts-nocheck
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/axios";
import { useToast } from '@/hooks/use-toast';

const placePatch = async (velId, placeId, body) => {
  const { data } = await axiosInstance.patch(
    `/api/abo/vel/${velId}/place/${placeId}?msdsId=${placeId}`,
    body
  );
  return data;
};

export const usePlacePatch = ({velId, placeId}) => {
  const {toast} = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body) =>
      placePatch(velId, placeId, body),
    onSuccess: () => {
      toast({
        variant: "default",
        title: "Votre club a été mis à jour",
      });
      queryClient.invalidateQueries({
        queryKey: ["vel", velId, "place"],
      });
      queryClient.refetchQueries(["vel", velId, "place"]);
    },
    onError: (e) => {
      console.error(e);
      toast({
        title: "Il y a un problème",
        variant: "destructive",
      });
    },
  });
};
